import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';
import dayjs from "dayjs";
import SingleFileUpload from '../../common/SingleDropzoneComponent';
import CustomDropdown from "../../common/CustomDropdown";
const CertificateAdd = ({fetchCertificateData,addPopupStatus, handleAddPopup, eventType, updateData}) => {

  const [updateId, setUpdateId] = useState("");
  const dateFormatList = "YYYY-MM-DD";
  const [formValues, setFormValues] = useState({
    year_of_fmas:'',
    president_name:''
  });

  const [errors, setErrors] = useState({
    year_of_fmas:'',
    president_name:'', 
    certificate_file:''
  });

  const yearData = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };    
    //----------------- President Sign ----------------
    const [certificateFile, setCertificateFile] =useState(null);
    const [certificateFileError, setCertificateFileError] =useState("");
    const handleCertificateUpload = (uploadedFile) => {
      setCertificateFile(uploadedFile);
      console.log("Uploaded File:", uploadedFile);
    };
    //-------------------------------------------------  

  const validate = () => {
    const newErrors = {
      year_of_fmas:'',
      president_name:'', 
      certificate_file:''
    };  
    if (!formValues.year_of_fmas) {
      newErrors.year_of_fmas = 'From date cannot be empty';
    }
    if (!formValues.president_name.trim()) {
      newErrors.president_name = 'President name cannot be empty';
    }
    if (!certificateFile && eventType === "Add") {
      newErrors.certificate_file = 'Secretary sign cannot be empty';
    }       
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };  

  const clearInputValues = () => {
    setErrors({ 
      year_of_fmas:'',
      president_name:'', 
      certificate_file:''
    });
    setFormValues({
      year_of_fmas:'',
      president_name:''
    });
    handleAddPopup(false);
  };  

  const addUpdateCertificate = async () => {
    if (validate()) {
      console.log('Post Data:', formValues); 
      try {
        const requestData = {
          ...formValues,
          ...{certificate_file: certificateFile || ''},
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/fmascertificate_data_update`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchCertificateData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }else {
      showToast("Please fill in the required details.", "error");
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        year_of_fmas: updateData.year_of_fmas || '',
        president_name: updateData.president_name || ''
      });
    }else{
      setErrors({
        year_of_fmas:'',
        president_name:'',
        certificate_file:''
      });
      setFormValues({
        year_of_fmas:'',
        president_name:''
      });  
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
    <ToastMessage/>    
    {addPopupStatus && (
      <div
        className={`extraspace_search_div search_div${addPopupStatus ? ' open' : ''}`}
      >
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>{eventType} Certificate</h3>
            <div className="input-group-append">
              <span
                onClick={() => clearInputValues()}
                className="search_toggle btn btn-danger"
              >
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <div>             
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Year <span className="text-danger">*</span></label>
                          {/* <input
                            type="date"
                            onClick={(e) => e.target.showPicker()}
                            className={`form-control ${
                              errors.year_of_fmas
                                ? "red_border"
                                : ""
                            }`}
                            value={
                              formValues.year_of_fmas
                                ? dayjs(
                                  formValues.year_of_fmas
                                  ).format(dateFormatList)
                                : ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "year_of_fmas",
                                e.target.value
                              )
                            }
                          /> */}
                          <div className="multiselect_div">
                          <CustomDropdown
                              dropdownData={yearData}
                              dropdownValue={
                                formValues.year_of_fmas
                              }
                              ShouldValidate={false}
                              textboxError={true}
                              setDropdownValue={(value) =>
                                setFormValues({
                                  ...formValues,
                                  year_of_fmas: value,
                                })
                              }
                              name="year"
                              fieldName="year_of_fmas"
                              errors={errors}
                              formValues={formValues}
                              eventType={
                                eventType === "Update"
                                  ? "Update"
                                  : "Add"
                              }
                              FeildName={"year_of_fmas"}
                        />
                        </div>
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.year_of_fmas}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>President Name <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${errors.president_name?"red_border":''}`}
                          value={formValues.president_name}
                          onChange={(e) => handleInputChange('president_name', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.president_name}</p>                          
                        )}
                      </div>

                    </div>
                      <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                          Certificate{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handleCertificateUpload}
                          setFileError={setCertificateFileError}
                          acceptedFilesType='image/jpeg,image/jpg,image/png'
                        />
                        {certificateFileError && (
                          <p className="text-danger pos_abos left_15">
                            {certificateFileError}
                          </p>
                        )}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.certificate_file}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {eventType === "Update" && updateData && updateData.certificate_file &&(
                              <a
                                href={`${baseUrl}/${updateData.certificate_file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-block"
                              >
                                View Document
                              </a>
                            )}
                        </div>
                      </div>      
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdateCertificate()} className="btn btn-outline-info">
                      {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default CertificateAdd;
